import React, { useState } from "react";
import { connect } from "react-redux";
import { Tag } from "antd";
import { BtnPrint } from "../../../components/Base";
import DanfeViewer from "./DanfeViewer";
import getCssVariable from "../../../Utils/getCssVariable";

function NotaFiscalDetalhePadrao({ dados }) {
  const [dadosImpressao, setDadosImpressao] = useState(null);

  return <>
    <div style={{ display: "flex", alignItems: "start" }}>
      <p><b>Natureza:</b> {dados.naturezaOperacao}</p>
      <p style={{ margin: "0 10px" }}><b>Número/Série:</b> {dados.numero}/{dados.serie}</p>
      <p><b>Chave:</b> {dados.chaveNfe} </p>
      <p style={{ marginLeft: 10 }}>
        <BtnPrint onClick={() => setDadosImpressao(dados)} />
      </p>
    </div>
    <p><b>Situação:</b> <Tag color={!!dados?.dataCancela ? getCssVariable("--vermelho-padrao") : getCssVariable("--verde-padrao")}>{!!dados?.dataCancela ? "Cancelada" : "Autorizada"}</Tag></p>

    <DanfeViewer visible={!!dadosImpressao} empresaPk={dadosImpressao?.empresaPk} chave={dadosImpressao?.chaveNfe} tipo={dadosImpressao?.tipoDanfe} onCancel={() => setDadosImpressao(null)} />
  </>;
}

export default connect(null, {})(NotaFiscalDetalhePadrao);
